var find_elements = window.find_elements;
var find_elements;
find_elements = function (target) {
  var container, hide, show;
  container = target.closest(target.data('container'));
  show = container.find(target.data('show'));
  hide = container.find(target.data('hide'));
  return {
    show: show,
    hide: hide
  };
};
$(document).on('click', 'a[data-more-link-behavior=true]', function (e) {
  var target;
  e.preventDefault();
  target = $(e.target);
  return target.trigger('show_more');
});
$(document).on('show_more', '*', function (e) {
  var hide, ref, show;
  e.stopPropagation();
  ref = find_elements($(e.target)), show = ref.show, hide = ref.hide;
  hide.addClass('hidden');
  hide.hide();
  show.removeClass('hidden');
  return show.show();
});
$(document).on('show_less', '*', function (e) {
  var hide, ref, show;
  e.stopPropagation();
  ref = find_elements($(e.target)), show = ref.show, hide = ref.hide;
  show.addClass('hidden');
  show.hide();
  hide.removeClass('hidden');
  return hide.show();
});
window.find_elements = find_elements;